import { Box, Button, Flex, Stack } from "@chakra-ui/react";
import { PhoneIcon } from "@chakra-ui/icons";
import React from "react";
import { addDays } from "../utils/functions";
import Countdown from "../components/data-display/Countdown";
import Icon from "../components/ui-elements/Icon";
import {
  ACCEPT_ACTION,
  CHAT_ACTION,
  DECLINE_ACTION,
} from "../stores/jobs/utils/request";

type Props = {
  onClick: (action: string) => void;
  isPending: boolean;
  dateCreated: any;
  [key: string]: any;
};

const BookingActions = ({
  onClick,
  isPending,
  dateCreated,
  ...rest
}: Props) => {
  const stopDate = addDays(dateCreated, 1);
  return (
    <Flex
      mt={[3, 5]}
      pb={2}
      px={[5, 6]}
      direction={["column", "row"]}
      justifyContent={["center", "space-between"]}
      {...rest}
    >
      <Button
        size="lg"
        width={["100%", "40%"]}
        onClick={() => onClick(ACCEPT_ACTION)}
        colorScheme="blue"
      >
        Accept
      </Button>

      <Box boxSize={[3, 6]} />

      <Flex>
        <Button
          size="lg"
          onClick={() => onClick(DECLINE_ACTION)}
          isFullWidth
          variant="outline"
        >
          Decline
        </Button>

        <Box boxSize={6} />

        <Button
          size="lg"
          isFullWidth
          leftIcon={<PhoneIcon />}
          iconSpacing={3}
          onClick={() => onClick(CHAT_ACTION)}
          variant="outline"
        >
          Chat
        </Button>
      </Flex>

      {isPending && (
        <Stack
          display={["flex", "none"]}
          isInline
          alignSelf="center"
          mt={5}
          align="center"
          px={2}
          py={1}
        >
          <Icon name="alarm-clock" size={5} color="red.500" />
          <Box fontSize="sm" pr={1}>
            <Countdown date={stopDate} variant="plain" /> left to respond
          </Box>
        </Stack>
      )}
    </Flex>
  );
};

export default BookingActions;
